import authService from 'authService'
import { UIRouterReact } from '@uirouter/react'
// envents
// helpers
import get from 'lodash/get'
import every from 'lodash/every'
import isEmpty from 'lodash/isEmpty'

export default function config(router: UIRouterReact) {
  router.transitionService.onBefore({}, (transition: any) => {
    const options = get(transition?.options(), 'custom', {})
    const from = transition.exiting()
    const actualView = from[0]

    if (transition.to().name !== 'App.login' && !authService.state.authToken)
      return transition.router.stateService.target('App.login')

    if (transition.to().name === 'App.login' && authService.state.authToken)
      return transition.router.stateService.target('App')

    const roles = transition.to()?.roles
    console.log(roles, authService.state.roles)
    if (!isEmpty(roles) && !!authService.state.roles && every(roles, (rol) => !authService.state.roles.includes(rol))) {
      console.log(transition.to())
      return transition.router.stateService.target('App')
    }

    authService.setDisplayed()
    return Promise.resolve()

    // if (options?.ignoreOnBefore) 

    // if (actualView?.data?.generalOnBefore)
    //   return new Promise((resolve, reject) => {
    //     event.emit(events?.GENERAL_ON_BEFORE, {
    //       resolve,
    //       reject,
    //       msg: actualView?.data?.generalOnBefore
    //     })
    //   })
  })

  return router.urlRouter.otherwise('/')
}
